<!--
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: qingqi qingqi@winning.com.cn
 * @LastEditTime: 2022-09-15 10:44:56
 * @FilePath: /nqc-ui/src/frameworks/layouts/BasicLayout.vue
-->
<template>
  <section>
    <!-- <server-error-info-wnd ref="serverErrorInfoWnd" /> -->
    <div :class="classObj" class="app-wrapper" flex="dir:top">
      <GlobalHeader v-if="hasTopMenu" @reload="reload" />
      <div
        v-if="hasLeftMenu && !isContentFillBody"
        flex="dir:top"
        style="height: 100%"
      >
        <sidebar class="sidebar-container" :style="styleSideBar" />
        <div class="main-container with-left-menu" flex-box="1" flex>
          <app-main ref="appMain" :reloading="reloading" />
        </div>
      </div>
      <div
        v-if="!hasLeftMenu || isContentFillBody"
        flex="dir:top"
        style="height: 100%"
      >
        <div class="main-container" flex-box="1" flex>
          <app-main ref="appMain" :reloading="reloading" />
        </div>
      </div>
    </div>
    <win-water-mark :text="waterMark" :count="50" diaphaneity="0.1" />
  </section>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView, GlobalHeader } from './components'
import { mapState } from 'vuex'
import eventBus from '@/frameworks/events/eventBus'
import { getUrlRootPath } from '@/common/utils/pathTools'
import ServerErrorInfoWnd from '@/frameworks/layouts/components/errorinfo/ServerErrorInfoWnd'
import { WindowPostMessageProxy } from 'window-post-message-proxy'

export default {
  name: 'BasicLayout',
  components: {
    Sidebar,
    AppMain,
    GlobalHeader
  },
  data() {
    return {
      reloading: false
    }
  },
  // mixins: [ResizeMixin],
  computed: {
    ...mapState({
      isContentFillBody: (state) => state.app.isContentFillBody,
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      isInsideFrame: (state) => state.app.isInsideFrame
      // allUnitList: (state) => state.orgStructure.allUnitList,
      // userContextHospital: (state) => state.user.userContextHospital
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        noTopbar: this.isInsideFrame,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    navStyle() {
      return this.$store.state.app.nav_style
    },
    // hasLeftMenu() {
    //   return this.$store.state.app.hasLeftMenu
    // },
    hasLeftMenu() {
      let navStyle = this.navStyle ? this.navStyle : 'topMenu'
      return !/topMenu|nonNav/.test(navStyle)
    },
    hasTopMenu() {
      return !/nonTopNav|nonNav/.test(this.navStyle)
    },
    styleSideBar() {
      let top = this.navStyle !== 'nonTopNav' ? '44px' : '0px'
      return {
        top: top
      }
    },
    userInfo() {
      return this.$store.state.user.loginUserInfo
    },
    waterMark() {
      const date = this.moment().format('YYYY年MM月DD日')
      const code = this.userInfo.UserId ? this.userInfo.UserId : ''
      const name = this.userInfo.UserName ? this.userInfo.UserName : ''
      return `${date} ${code} ${name}  `
    }
  },
  created() {
    // 监听token 刷新失败事件，并弹框提示重新登录
    eventBus.$on('REFRESH_TOKEN_FAILE', (faileInfo) => {
      // 如果是嵌入到护理门户中，发送session失效消息到父级window（也就是护理门户系统中）
      this.sendSessionInvaildMessageToParentWindow()
    })
  },
  methods: {
    reload() {
      this.reloading = !this.reloading
    },
    sendSessionInvaildMessageToParentWindow() {
      const windowPostMessageProxy = new WindowPostMessageProxy()
      const message = {
        // 消息key为USER_SESSION_INVALID, app为系统名称，用于上级window识别是哪个系统发出来的消息
        key: 'USER_SESSION_INVALID',
        app: 'bcs-admin'
      }
      windowPostMessageProxy
        .postMessage(window.parent, message)
        .then((response) => {
          if (response.isMessageAccept) {
            console.log('父级window已响应session失效消息.')
          }
        })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '~@/common/styles/mixin.scss';
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  // padding-top: 44px;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
  &.noTopbar {
    padding-top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>
